import type { AssetType } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { categoriesList, criticalityLevelsList, inUseStatusesList } from '../AssetType.Mappings';
import { gql } from '@apollo/client';
import { getTenantList, getUserList } from '#/graphql/queries';

const columns: ColumnProps<AssetType>[] = [
  {
    dataField: 'id',
    caption: 'ID',
    visible: false,
    dataType: 'string',
    showInColumnChooser: false,
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    visible: true,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'createdAt',
    caption: 'Created At',
    visible: false,
    dataType: 'datetime',
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'createdByUser.name',
    caption: 'Created By',
    // calcDisplayValue: (row) => row.createdByUser?.name ?? '',
    visible: false,
    dataType: 'string',
  },
  {
    dataField: 'updatedAt',
    caption: 'Updated At',
    visible: false,
    dataType: 'datetime',
  },
  {
    dataField: 'updatedByUser.name',
    caption: 'Updated By',
    // calcDisplayValue: (row) => row.updatedByUser?.name ?? '',
    visible: false,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getUserList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'name',
    caption: 'Name',
    dataType: 'string',
    visible: true,
    fixed: false,
    openOnClick: true,
  },
  {
    dataField: 'description',
    caption: 'Description',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'category',
    caption: 'Category',
    dataType: 'string',
    visible: true,
    lookup: {
      nullable: true,
      dataSource: categoriesList,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  {
    dataField: 'criticalityLevel',
    caption: 'Criticality Level',
    dataType: 'string',
    visible: false,
    lookup: {
      nullable: true,
      dataSource: criticalityLevelsList,
      displayExpr: 'label',
      valueExpr: 'value',
    },
  },
  {
    dataField: 'expectedUsefulLife',
    caption: 'Expected Useful Life',
    dataType: 'number',
    visible: false,
    calcDisplayValue: (row) =>
      !!row.expectedUsefulLife && row.expectedUsefulLife > 0
        ? `${row.expectedUsefulLife} ${row.expectedUsefulLife === 1 ? 'year' : 'years'}`
        : '',
  },
  {
    dataField: 'defaultWarrantyPeriod',
    caption: 'Default Warranty Period',
    dataType: 'number',
    visible: false,
  },
  {
    dataField: 'defaultRiskScore',
    caption: 'Default Risk Score',
    dataType: 'number',
    visible: false,
  },
  {
    dataField: 'inUseStatus',
    caption: 'Status',
    dataType: 'string',
    visible: false,
    lookup: {
      nullable: true,
      dataSource: inUseStatusesList,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  {
    dataField: 'thirdPartyId',
    caption: 'Third Party ID',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'thirdPartySource',
    caption: 'Third Party Source',
    dataType: 'string',
    visible: false,
  },
  // {
  //   dataField: 'image',
  //   caption: 'Image',
  //   dataType: 'string',
  //   visible: false,
  // },
];

export default columns;
